// extracted by mini-css-extract-plugin
module.exports = {"checkBoxWrapper":"styles__checkBoxWrapper___2xzLL","checkBoxLabel":"styles__checkBoxLabel___3idvg"};